import {
  Link as RouterLink,
  useHistory
} from "react-router-dom";
import {
  Box,
  Image,
  Link
} from "@chakra-ui/react";
import { Auth } from "@aws-amplify/auth";

import { Text } from "src/components/text";
import { useAuthContext } from "src/hooks/useAuthContext";

export const Header: React.FC = () => {
  const history = useHistory();
  const { authDataState } = useAuthContext();

  const onLogOut = async () => {
    await Auth.signOut();
    history.push("/");
    history.go(0);
  };

  return (
    <nav>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        paddingBottom={10}
        paddingTop={5}
      >
        <Box
          display="flex"
          cursor="pointer"
          flexDirection="row"
          alignItems="center"
          onClick={() => history.push("/")}
        >
          <Image
            src="/braided-logo.svg"
            w="30"
            h="30"
            pr={5}
          />

          <Text bold>
            LGM
          </Text>
        </Box>

        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"

        >

          {authDataState.authenticated ? (
            <>
              <Link
                as={RouterLink}
                paddingX={5}
                to="/conversation/create"
              >
                Create new session
              </Link>

              <Link
                as={RouterLink}
                paddingX={5}
                to="/conversation/invitations"
              >
                Manage invites
              </Link>

              {authDataState.user?.admin && (
                <>
                  <Link
                    as={RouterLink}
                    paddingX={5}
                    to="/conversation/admin"
                  >
                    All Sessions
                  </Link>

                  <Link
                    as={RouterLink}
                    paddingX={5}
                    to="/users"
                  >
                    Users
                  </Link>

                  <Link
                    as={RouterLink}
                    paddingX={5}
                    to="/missions"
                  >
                    Missions
                  </Link>
                </>
              )}

              <Link
                as={RouterLink}
                paddingX={5}
                to="/conversation/history"
              >
                History
              </Link>

              <Link
                onClick={onLogOut}
                paddingX={5}
              >
                Log out
              </Link>
            </>
          ) : (
            <Link
              as={RouterLink}
              to="/login"
            >
              Log in
            </Link>
          )}

        </Box>
      </Box>
    </nav>
  );
};